import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, ControlContainer, FormControlDirective } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StaticDictionaryItem } from 'src/app/shared/model/StaticDictionaryItem';
import { StaticDictionaryService } from 'src/app/shared/services/static-dictionary.service';
import { ControlSettings } from '../../ControlSettings';
import { AutoComplete } from '../operators/autocomplete';

@Component({
  selector: 'static-dictionary-text-autocomplete-ctrl',
  templateUrl: './static-dictionary-text-autocomplete.component.html',
  styleUrls: ['./static-dictionary-text-autocomplete.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: StaticDictionaryTextAutocompleteComponent,
    multi: true
  }]
})
export class StaticDictionaryTextAutocompleteComponent implements ControlValueAccessor,OnInit  {

  constructor(protected controlContainer: ControlContainer, private staticDictionary: StaticDictionaryService) {

  }

  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;
  

  @Input() public formControlName: string;
  @Input() caption: string;
  @Input() settings:ControlSettings = {};
  @Input() staticDictionaryName: string;
  @Input() allowedValuesLimitation : number[];
  @Input() orderById : boolean;
  @Input() allowCustom = true;
  @Input() allowedValueCheck: (item: number) => boolean;

  @Output() valueChangeEvent = new EventEmitter<number>();
 
  textField  = 'value';
  valueField  = 'id';
  defaultSettings:ControlSettings = {fxFill:false};

  valueList$: Observable<StaticDictionaryItem[]>;
  displayList$: Observable<StaticDictionaryItem[]>;

  term$ = new BehaviorSubject<string>('');


  ngOnInit(): void {
     Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;

    this.valueList$ = this.staticDictionary.getStaticDictionary(this.staticDictionaryName);

    if(this.allowedValueCheck){
      this.valueList$ = this.valueList$.pipe(map(x => x.filter(r => this.allowedValueCheck(r.id))) );
    }

    if(this.allowedValuesLimitation){
      this.valueList$ = this.valueList$.pipe(map(x => x.filter(r => this.allowedValuesLimitation.includes(r.id))) );
    }
   
    if(this.orderById){
      this.valueList$ = this.valueList$.pipe(map(x => x.sort(this.orderDictionaryItemsById)) );
    }

    this.displayList$ = this.term$.pipe(
      AutoComplete.autocomplete(500, (term => this.setDisplayList(term))));

      // if(this.control.value != null){
      //   this.filterChange(this.control.value);
      // }
   
  }

   setDisplayList(term:string) : Observable<StaticDictionaryItem[]>{ 

    return this.valueList$.pipe(map(x=> x.filter(r => r.value.toLowerCase().includes(term?.toLowerCase()))));
   }

  orderDictionaryItemsById(a:StaticDictionaryItem, b:StaticDictionaryItem): number {
     return a.id - b.id;
  }

  onChange(value: number) {
    this.valueChangeEvent.emit(value);
  }

   public filterChange(filter: any): void {
    this.term$.next(filter);
     this.control.markAsTouched();
 }

  public get control() {
    return this.controlContainer.control.get(this.formControlName);
  }

  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }

}


